import { render, staticRenderFns } from "./LeadsDigital.vue?vue&type=template&id=4132ad0c&"
import script from "./LeadsDigital.vue?vue&type=script&lang=js&"
export * from "./LeadsDigital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QToggle,QCard,QTable,QTd,QRating,QSelect} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QToggle,QCard,QTable,QTd,QRating,QSelect})
